const __WEBPACK_NAMESPACE_OBJECT__ = require("plugin-joblog/shared/lib/approval-overview-related-pages-button-registry");